//eslint-disable-next-line import/prefer-default-export
export const lsScheduleCycles = {
    weekly: 7,
    biweekly: 14,
    monthly: 28,
};
